import { bitcashPrivateRoom } from 'app-view/hooks/use-realtime'

export const useRealTimeTrustNetworkFollowingAccounts = () => {
  const _followingAccount = bitcashPrivateRoom.useColyseusState((state) => state.followingAccount)
  const followingAccount = _followingAccount ? _followingAccount.toArray() : []
  return followingAccount
}
